//import deco from "../img/deco.svg";
import imgnumeralia from "../assets/numeralia-new.png";
import React, { useEffect, useState } from "react";
import axios from 'axios';

const Numeralia = () => {


  const [manman, setmanman] = useState(null); 
  const [manwoman, setmanwoman] = useState(null); 
  const [womanman, setwomanman] = useState(null); 
  const [womanwoman, setwomanwoman] = useState(null); 

  useEffect(() => {
    
    var ahora = new Date();
    var milisegundos = ahora.getMilliseconds();

    axios({
      url: 'https://mmkg.net/api/casate/total-register-by-gender/' + 100 + "?v=" + milisegundos,
      method: 'GET',
    })
    .then((response) => {
      if(response.data.status === true){
        setmanman(response.data.man_man);
        setmanwoman(response.data.man_woman);
        setwomanman(response.data.woman_man);
        setwomanwoman(response.data.woman_woman);
      }else{
        return false;
      }
    })
    .catch((e) => {
      console.error(e);
    })
   }, []);



  return (
    <>
      {/* <div className="col-12 text-center">
        <h2 className="numeralia__title">Numeralia</h2>
        <img className="global__deco" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" />
        <p className="numeralia__p mt-3">
          ¿Cómo van las propuestas de este Cásate?
        </p>
      </div> */}

      <div className="container py-3">
        <div className="row justify-content-center">
          <img src={imgnumeralia} alt="Numeralia" className="numeraliaImg"/>
        </div>
      </div>
      <div className="col text-center">
        <div className="container mt-3">
          <div className="row">
            <div className="col-6 col-lg-3">
              <div className="numeralia__box">
                <h3 className="numeralia__title_sexo mb-3 mt-5">Hombre & Mujer</h3>
                {/* <img className="global__deco" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" /> */}
                <div className="numeralia__circle">
                  <p>{manwoman}</p>
                </div>
              </div>
            </div>
            <div className="col-6 col-lg-3">
              <div className="numeralia__box">
                <h3 className="numeralia__title_sexo mb-3 mt-5">Mujer & Hombre</h3>
                {/* <img className="global__deco" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" /> */}
                <div className="numeralia__circle">
                  <p>{womanman}</p>
                </div>
              </div>
            </div>
            <div className="col-6 col-lg-3 mt-4 mt-lg-0">
              <div className="numeralia__box">
                <h3 className="numeralia__title_sexo mb-3 mt-5">Hombre & Hombre</h3>
                {/* <img className="global__deco" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" /> */}
                <div className="numeralia__circle">
                  <p>{manman}</p>
                </div>
              </div>
            </div>
            <div className="col-6 col-lg-3 mt-4 mt-lg-0">
              <div className="numeralia__box">
                <h3 className="numeralia__title_sexo mb-3 mt-5">Mujer & Mujer</h3>
                {/* <img className="global__deco" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" /> */}
                <div className="numeralia__circle">
                  <p>{womanwoman}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <img className="global__deco mt-5" src={process.env.PUBLIC_URL+'/img/deco.svg'} alt="Decoración" /> */}
      </div>
    </>
  );
};

export default Numeralia;
